import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';
import { FormManagerPageReducerHelper } from '../form-manager-page.reducer-helper';

export const loadSuccessReducer = (
    state = initialState,
    action: actions.LoadSuccess
): State => {
    if (state.loaded) {
        return state;
    }

    return {
        ...state,
        account: action.payload.account,
        membership: action.payload.membership,
        accessGroups: {
            ...state.accessGroups,
            ...FormManagerPageReducerHelper.arrayToState(
                action.payload.accessGroups
            )
        },
        controlType: {
            ...state.controlType,
            ...FormManagerPageReducerHelper.arrayToState(
                action.payload.controlTypes
            )
        },
        control: {
            ...state.control,
            ...FormManagerPageReducerHelper.arrayToState(
                action.payload.controls
            )
        },
        form: {
            ...state.form,
            ...FormManagerPageReducerHelper.arrayToState(
                action.payload.forms
            )
        },
        group: {
            ...state.group,
            ...FormManagerPageReducerHelper.arrayToState(
                action.payload.groups
            )
        },
        loaded: true,
        user: action.payload.user
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/load-success.reducer.ts